import {ISearchState} from '@app/shared/models/search-state.model';
import {createReducer, on} from '@ngrx/store';
import {EActionStatus} from 'src/app/shared/enums/action-status.enum';
import {resetSearch, searchAction, searchEffectError, searchEffectFailure, searchEffectSuccess} from './search.actions';

export const initialState: ISearchState = {
  status: EActionStatus.Initial,
  successResponse: null,
  failureReason: '',
  errorMessage: '',
};
export const searchReducer = createReducer(
  initialState,
  on(searchAction, state => ({
    ...state,
    status: EActionStatus.Pending,
  })),
  on(searchEffectSuccess, (state, {response}) => ({
    ...state,
    status: EActionStatus.Success,
    successResponse: response,
  })),
  on(searchEffectFailure, (state, {reason}) => ({
    ...state,
    status: EActionStatus.Failure,
    failureReason: reason,
  })),
  on(searchEffectError, (state, {error}) => ({
    ...state,
    status: EActionStatus.Error,
    errorMessage: error,
  })),
  on(resetSearch, state => ({
    ...state,
    status: EActionStatus.Initial,
    successResponse: null,
    failureReason: '',
    errorMessage: '',
  }))
);
